import React, { useState, useEffect } from 'react';
import isMobile from 'is-mobile';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Collapse } from '@blueprintjs/core';
import Link from 'next/link';
import Image from 'next/image';

import Logo from '../imgs/logo.svg';
import PersonLight from '../imgs/personLight.svg';
import { redirectUrl } from './config/endPoints';

import MenuIcon from '../imgs/menuIcon.svg';
import Cross from '../imgs/cross.svg';
import useWindowDimensions from './utils/ScreenSize';

const DocsHeader = (props) => {
  const {
    openSideNav,
    setOpenSideNav,
    haveToken,
    setShowLogin,
    setShowSignup,
  } = props;

  const { width } = useWindowDimensions();

  return (
    <div className="oldHeader">
      <nav className="navbar">
        <div className="nav_container">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: width < 800 ? '100%' : 'unset',
            }}
          >
            {openSideNav ? null : (
              <div className="navbar__logo">
                <Link href="/" title="Home Page" passHref>
                  <div className="logoBox">
                    <Image src={Logo} alt="Mendelgen Logo" />
                  </div>
                </Link>
              </div>
            )}
            {width < 800 ? (
              <div
                className="navbar__actions--menuIcon"
                style={{ paddingRight: '20px' }}
                onClick={(e) => setOpenSideNav(!openSideNav)}
              >
                <Image src={MenuIcon} alt="Open Menu" />
              </div>
            ) : null}
          </div>
          {width > 800 ? (
            <div>
              {!haveToken && (
                <button
                  id="signin"
                  className="sign"
                  onClick={() => {
                    setShowLogin(true);
                  }}
                  style={{ display: 'unset' }}
                >
                  <span className="navLink">Sign In</span>
                </button>
              )}
              <Button
                id="signup"
                className="sign"
                onClick={() => {
                  if (haveToken) {
                    document.location.href = redirectUrl;
                  } else {
                    setShowSignup(true);
                  }
                }}
                style={{
                  marginLeft: haveToken ? 25 : 0,
                  display: 'unset',
                  minWidth: '100px',
                }}
              >
                <span className="navLink">
                  {haveToken ? 'Go To App' : 'Sign Up'}
                </span>
              </Button>
            </div>
          ) : null}
        </div>
      </nav>
    </div>
  );
};

export default DocsHeader;
